import { useEffect, useRef } from 'react';

const CookieLayer = ({ setShowCookie }) => {
    const ref = useRef();

    const acceptCookieNote = () => {
        window.localStorage.setItem('cookieAccepted', 'true');
        setShowCookie(false);
    };

    useEffect(() => {
        if (!ref.current) {
            return () => {};
        }

        // Prevent modal from closing due to clicking outside or pressing escape. Only a click on the accept button
        // should close it.
        function preventModalClose(event) {
            if (
                event.target.nodeName === 'SBK-MODAL'
                && (event.type === 'click' || (event.type === 'keydown' && event.key === 'Escape'))
            ) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
            }
        }
        ref.current.addEventListener('click', preventModalClose, true);
        ref.current.addEventListener('keydown', preventModalClose, true);

        return () => {
            ref.current?.removeEventListener('click', preventModalClose);
        };
    }, [ref.current]);

    return (
        <sbk-modal ref={ref} heading="Ihre Website-Einstellungen" hideclosebutton open>
            <div>
                <p>
                    Wir verwenden erforderliche Cookies, die für den Betrieb der Webseite notwendig sind, um
                    Ihnen ein optimales Webseiten-Erlebnis zu bieten.
                </p>
            </div>
            <div slot="footer">
                <sbk-button onClick={acceptCookieNote} size="small">Ok</sbk-button>
            </div>
        </sbk-modal>
    );
};

export default CookieLayer;
